(function () {
    'use strict';

    angular.module("imApp").factory("stockStockBatchAssignedService", ['$ihttp', function ($ihttp) {
        let service = {
            listAssigned: function (parms) {
                return $ihttp.post({
                    method: 414,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
